// Przemielilem pod nas "vue-cookie-law" 
// ("npm: https://www.npmjs.com/package/vue-cookie-law")
// ("GIT: https://github.com/apertureless/vue-cookie-law")
// + pozbylem sie wymaganego: "~@nextindex/next-scss/next-scss.scss"
// + zamienilem funkcje z "tiny-cookie" na te z "js-cookie"
// 2018-12-11 ~kp

Vue.component('cookie-law', {
    template: '#vue-cookie-law',
    props: {
      buttonText: {
        type: String,
        default: locales('common.understand')
      },
      buttonLink: {
        type: [String, Object],
        required: false
      },
      buttonLinkText: {
        type: String,
        default: locales('common.more_information')
      },
      buttonLinkNewTab: {
        type: Boolean,
        default: false
      },
      theme: {
        type: String,
        default: 'base'
      },
      /**
       * Cookie Container position
       * bottom, top
       * @type {Object}
       */
      position: {
        type: String,
        default: 'bottom'
      },
      /**
       * Transition name has following possibilities
       * slideFromBottom
       * slideFromTop
       * fade
       * @type {Object}
       */
      transitionName: {
        type: String,
        default: 'slideFromBottom'
      },
      buttonClass: {
        type: String,
        default: 'Cookie__button Cookie__button-info'
      },
      buttonAcceptClass: {
        type: String,
        default: 'Cookie__button Cookie__button-accept'
      },
      storageName: {
        type: String,
        default: 'cookie:accepted'
      }
    },
    data: function () {
      return {
        supportsLocalStorage: false,
        isOpen: false
      }
    },
    computed: {
      message: function () {
        return store.state.config.cookie.message;
      },
      moreInfoTMP: function () {
        return store.state.config.cookie.links;
      },
      containerPosition: function () {
        return 'Cookie--'+ this.position;
      },
      cookieTheme: function () {
        return 'Cookie--'+ this.theme;
      },
      externalButtonLink: function () {
        return typeof this.buttonLink === 'string' && this.buttonLink.length;
      },
      internalButtonLink: function () {
        return typeof this.buttonLink === 'object' && this.buttonLink != null && Object.keys(this.buttonLink).length;
      },
      target: function () {
        return this.buttonLinkNewTab ? '_blank' : '_self';
      }
    },
    created: function () {
      // Check for availability of localStorage
      try {
        test = '__vue-cookielaw-check-localStorage';

        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
      } catch (e) {
        console.info('Local storage is not supported, falling back to cookie use');
        this.supportsLocalStorage = false;
      }

      if (!this.getVisited() === true) {
        this.isOpen = true;
      }
    },
    methods: {
      setVisited: function  () {
        if (this.supportsLocalStorage) {
          localStorage.setItem(this.storageName, true);
        } else {
          Cookies.set(this.storageName, true);
        }
      },
      getVisited: function () {
        if (this.supportsLocalStorage) {
          return localStorage.getItem(this.storageName);
        } else {
          return Cookies.get(this.storageName);
        }
      },
      accept: function () {
        this.setVisited();
        this.isOpen = false;
        this.$emit('accept');
      },

      close: function () {
        this.isOpen = false;
      }
    }
});